/**
 * Created by mariushirjanu on 11/10/2017.
 */
import { HttpDataService, IHttpDataCache } from '../http/http-data.service';

import { ICountryExtended, IRegion, IState } from '../../../type_definitions/datatypes';
import { Injectable } from '@angular/core';

@Injectable()
export class CountryDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  // get list of countries
  public getAllCountries():Promise<ICountryExtended[]> {
    return this.cache.doGET(
      'rest/countries', {}, undefined, 'Error loading countries'
    );
  }

  public getStates(countryId:number):Promise<IState[]> {
    return this.cache.doGET(
      `rest/states/${countryId}`,
      undefined,
      undefined,
      'Error loading states'
    );
  }

  public listContinents():Promise<IRegion[]> {
    return this.cache.doGET(
      'rest/continents', {}, undefined, 'Error loading continents'
    );
  }

  public clear() {
    this.cache.clear();
  }
}